import { fitCover, type Rect, type Size } from '@fotoboek/geometry';
import type { PhotoPlacement } from '@fotoboek/domain';

/**
 * Inverse of `applyPhotoPlacement`: given the final on-screen rect of the
 * image (in the same mm/frame coordinate space) plus the frame and the
 * image's natural pixel size, recover the normalized placement the model
 * stores. Used when the user drags/zooms an image in crop mode.
 */
export function placementFromImageRect(
  frame: Size,
  image: Size,
  imageRect: Rect,
  rotation: number,
  flipX: boolean,
  flipY: boolean,
): PhotoPlacement {
  const base = fitCover(frame, image);
  const scale = base.width > 0 ? imageRect.width / base.width : 1;
  const leftoverX = Math.max(0, (imageRect.width - frame.width) / 2);
  const leftoverY = Math.max(0, (imageRect.height - frame.height) / 2);
  const centeredX = (frame.width - imageRect.width) / 2;
  const centeredY = (frame.height - imageRect.height) / 2;
  const offsetX = leftoverX > 0 ? (imageRect.x - centeredX) / leftoverX : 0;
  const offsetY = leftoverY > 0 ? (imageRect.y - centeredY) / leftoverY : 0;
  return {
    scale: Math.max(0.1, scale),
    offsetX: Math.max(-1, Math.min(1, offsetX)),
    offsetY: Math.max(-1, Math.min(1, offsetY)),
    rotation,
    flipX,
    flipY,
  };
}
